import { Navigate } from "react-router-dom";
import { useContext } from "react";
import systemContext from "../../_context/systemContext";

const PermisosPerfil = ({ perfilesPermitidos, children }) => {
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
    const idPerfil = Number(user?.idPerfil);
    if (!user || !idPerfil) {
        return <Navigate to="/" replace />;
    }
    if (!perfilesPermitidos.includes(idPerfil)) {
        return <Navigate to="/" replace />;
    }
    return children;
};
export default PermisosPerfil;